import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tlr_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login' && window.location.pathname !== '/admin/login' && window.location.pathname !== '/register') {
      localStorage.removeItem('tlr_token');
      if (window.location.pathname.startsWith('/admin')) {
        window.location.href = '/admin/login';
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export const getImageUrl = (path) => {
  if (!path) return null;
  if (path.startsWith('http')) return path;
  return `${BACKEND_URL}${path}`;
};

export const PLACEHOLDER_IMAGE = 'https://images.pexels.com/photos/1645795/pexels-photo-1645795.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';
export const PLACEHOLDER_IMAGE_2 = 'https://images.pexels.com/photos/8251473/pexels-photo-8251473.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940';

export default api;
